export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-pdf-e0a218a6b73f69754cb22bf83bb1dbb4.svg";